import classNames from 'classnames';

import { ArticleFragmentFragment, CaseStudiesFragmentFragment } from '../../__generated__/graphql';
import AppImage from '../../components/AppImage';
import ButtonLink from '../../components/Button/ButtonLink';
import { Heading3, Paragraph } from '../../components/Text';
import Section from '../../layout/Section';
import SectionTitle from '../../layout/Section/SectionTitle';
import { ContentBlock } from '../types';

import style from './case-studies.module.css';

const CaseStudies: ContentBlock<CaseStudiesFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.caseStudies;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <Section
      backgroundColor={contentBlockProps.darkBackground ? 'black' : 'white'}
      id={contentBlockProps.sectionId}
    >
      <SectionTitle>
        {contentBlockProps.sectionTitle}
      </SectionTitle>

      <ul
        className={classNames(
          style.list,
        )}
      >
        {contentBlockProps.items?.map(item => {
          const article = (item?.post?.nodes as ArticleFragmentFragment[])[0];

          if (article) {
            return (
              <li key={article.id}>
                <div className={style.imageContainer}>
                  {article.featuredImage?.node && (
                    <AppImage
                      fallbackHeight={article.featuredImage.node.mediaDetails?.height ?? 400}
                      fallbackWidth={article.featuredImage.node.mediaDetails?.width ?? 600}
                      image={article.featuredImage}
                      withBorder
                    />
                  )}
                </div>

                <div className={style.contentContainer}>
                  <Heading3>
                    {article.title}
                  </Heading3>

                  <Paragraph>
                    {item?.description}
                  </Paragraph>

                  <ButtonLink
                    linkFragment={{
                      title: contentBlockProps.ctaText,
                      url: article.uri ?? '',
                    }}
                  />
                </div>
              </li>
            );
          }
        })}
      </ul>
    </Section>
  );
};

export default CaseStudies;
